/**
 * @desc 获取缓存
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<
  ObjectMap<string, defs.activiti.BpmHostUrlConvert>
>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/simpleTodoLinks/getCache`, {
      method: "GET",

      ...options,
    }),
  );
}
